import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import * as flowGuards from './core/guards';
import { AuthGuard } from './core/guards/auth/auth.guard';
import { SecureContainerComponent } from './secure/secure-container/secure-container.component';
export const divorceRoutes: Routes = [
  {
    path: 'secure/divorce',
    canActivate: [AuthGuard],
    component: SecureContainerComponent,
    children: [
      // divorce secure pages
      {
        path: 'upload',
        canActivate: [flowGuards.ClientGuard],
        loadChildren: () =>
          import('./secure/document-upload/document-upload.module').then(
            (m) => m.DocumentUploadModule,
          ),
      },
      {
        path: 'holdings-review',
        loadChildren: () =>
          import(
            './secure/internal-transfer-holdings-review/containers/internal-transfer-holdings-review-classic/internal-transfer-holdings-review-classic.module'
          ).then((m) => m.InternalTransferHoldingsReviewClassicModule),
      },
      {
        path: 'terms',
        loadChildren: () => import('./secure/terms/terms.module').then((m) => m.TermsModule),
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forRoot(divorceRoutes)],
  exports: [RouterModule],
})
export class DivorceRoutingModule {}
